import { useEffect } from 'react';
import { extractCSRFToken } from '../utils/csrf';
import { API_ENDPOINTS } from '../config';

/**
 * Hook to fetch and cache CSRF token on component mount
 * Should be used in App.js or a top-level component
 */
export function useCSRF() {
  useEffect(() => {
    // Fetch CSRF token from health endpoint or any GET endpoint
    fetch(`${API_ENDPOINTS.API_BASE_URL}/api/health`, {
      method: 'GET',
      credentials: 'include',
    })
      .then(response => {
        extractCSRFToken(response);
      })
      .catch(() => {
        // If health endpoint fails, try profile endpoint if user is logged in
        fetch(`${API_ENDPOINTS.PROFILE}`, {
          method: 'GET',
          credentials: 'include',
        })
          .then(response => {
            extractCSRFToken(response);
          })
          .catch(() => {
            // Silent fail - token will be fetched on next API call
          });
      });
  }, []);
}

